import { useTranslations } from 'next-intl';
import {
  ContentLayout,
  MinimalPageContent,
} from '@silvertours/common-landingpages-view';
import {
  StageLegacy,
  ContentArticle,
  Author,
  AuthorInTitle,
} from '@silvertours/front-features';

import { Body } from '../body';

/**
 * This is a page template that only renders the introduction and content modules.
 * Create for legal but can be used for rendering other pages where we don't
 * want to render legacy elements. To use the template, add necessary slug
 * or domainKeys in i18n/json/app/pageContent/[LOCALE].ts
 */
const MinimalPage = ({
  content: {
    article,
    introduction,
    stage,
    author,
    textContent: { primaryHeadline },
  },
  ...commonProps
}: ContentLayout<MinimalPageContent>) => {
  const t = useTranslations('features');
  const translations = t.raw('article' as any);

  return (
    <Body
      title={primaryHeadline}
      author={author && <AuthorInTitle {...author} />}
      stage={
        stage && (
          <StageLegacy.Stage
            content={stage.content}
            headline={primaryHeadline}
            isMinimal
          />
        )
      }
      content={({ container, containerModule, contentModule }) => [
        containerModule(
          'introduction-content',
          <ContentArticle
            modules={introduction?.segments ?? []}
            translations={translations}
          />,
          !!introduction?.segments,
        ),
        container('content-modules', [
          contentModule(
            'article',
            <ContentArticle
              modules={article.segments}
              translations={translations}
            />,
          ),
        ]),
        containerModule('author', author && <Author {...author} />, !!author),
      ]}
      includeSearch={false}
      includeTrustSeals={false}
      isMinimal
      {...commonProps}
    />
  );
};

export { MinimalPage };
